import { useEmployeeNotifications, useHrInvalidate } from "@/hooks/use-hr-queries";
import { hrEmployeeApi } from "@/lib/api/hr";
import { Button } from "@/components/ui/button";
import { EmptyState, Page, QueryGate } from "@/components/shell/page";
import { cn } from "@/lib/utils";

export default function EmployeeNotificationsPage() {
  const { data, isLoading, error } = useEmployeeNotifications();
  const invalidate = useHrInvalidate();

  return (
    <QueryGate loading={isLoading} error={error || !data ? "Could not load notifications." : null}>
      {data && (
        <Page title="Notifications" description="Task reminders, leave decisions, and awards.">
          {data.length === 0 && (
            <EmptyState title="You're caught up" body="New notices will land here." />
          )}
          <ul className="space-y-3">
            {data.map((item: any) => (
              <li
                key={item.id}
                className={cn(
                  "rounded-xl border bg-card p-5 shadow-sm",
                  item.is_read && "opacity-70"
                )}
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="font-medium">{item.title}</p>
                    {!item.is_read && (
                      <p className="mt-1 text-xs font-medium uppercase tracking-wide text-primary">Unread</p>
                    )}
                  </div>
                  {!item.is_read && (
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={async () => {
                        await hrEmployeeApi.markRead(item.id);
                        invalidate();
                      }}
                    >
                      Mark read
                    </Button>
                  )}
                </div>
                <p className="mt-2 text-sm text-muted-foreground">{item.body}</p>
              </li>
            ))}
          </ul>
        </Page>
      )}
    </QueryGate>
  );
}
